import React from "react";
import Security from "./security.svg";

function SecurityControlIcon() {
  return <img src={Security} alt="Security Icon" />;
}

export default SecurityControlIcon;
